import { Skeleton } from 'atp-react-ui';

import { InputSkeleton } from '@/_components';

export function Loading() {
  return (
    <>
      <header className="max-auto container font-serif">
        <Skeleton className="h-10 w-60" />
        <Skeleton className="mt-2 h-6 w-24" />
      </header>

      <main className="container mx-auto mt-6 flex flex-col gap-10 lg:flex-row">
        <section className="border-border flex-1 rounded-3xl rounded-tr-none border p-14">
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="mt-2 h-8 w-1/2" />
          <div className="mt-6 grid grid-cols-2 gap-4">
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <div className="col-span-2">
              <Skeleton className="h-8 w-3/4" />
            </div>
            <InputSkeleton formItemClassName="col-span-2" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
            <InputSkeleton formItemClassName="col-span-2 md:col-span-1" className="h-[3.125rem] w-full rounded-none" />
          </div>
        </section>

        <section className="flex flex-1 flex-col">
          <div className="flex flex-col gap-6 rounded-3xl rounded-tr-none border p-14">
            <div className="shrink-0">
              <Skeleton className="h-8 w-3/4" />
              <Skeleton className="mt-2 h-8 w-1/2" />
            </div>

            <div className="mt-2 flex flex-nowrap items-center justify-between">
              <div className="flex flex-1 items-center gap-4">
                <div className="flex size-16 shrink-0 grow-0 items-center justify-center rounded-xl rounded-tr-none shadow-md shadow-black/30">
                  <Skeleton className="size-16" />
                </div>
                <div className="flex-1">
                  <Skeleton className="h-8 w-3/4" />
                  <Skeleton className="mt-2 h-4 w-1/2" />
                </div>
              </div>

              <Skeleton className="mt-2 h-4 w-20" />
            </div>

            <Skeleton className="mt-4 h-8 w-3/4" />

            <div className="mt-2 flex w-full flex-col gap-4">
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-24" />
                <Skeleton className="h-7 w-16" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-24" />
                <Skeleton className="h-7 w-16" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-24" />
                <Skeleton className="h-7 w-16" />
              </div>
            </div>
          </div>

          <div className="mt-10 w-full">
            <Skeleton className="h-14 rounded-full" />
          </div>
        </section>
      </main>
    </>
  );
}
